import shiroApi from "./shiroApi"
import goodsApi from "./goodsApi"
import orderApi from "./orderApi"
import msgApi from "./msgApi"
const api = '/checkmall-system/api'
export default {
    /**字典查询 */
    dicApi: {
        getDic: api + "/dic/list",
    },
    pageInfoApi: {
        getFooterInfo: api + "/system/getSystemInfo",
        getHeaderNumber: api + '/system/getHeadStatisInfo',
        // 获取送检流程
        getStep: api + '/step/getStep',
    },
    /**头部信息 */
    headInfo: {
        info: "/web/statistics/headInfo",
    },
    /** 用户认证相关接口 */
    shiroApi,
    /** 商品相关接口 */
    goodsApi,
    /** 订单相关接口 */
    orderApi,
    /** 消息相关接口 */
    msgApi,
    // 首页头部轮播及资源文件
    bannerApi: {
        getBanner: api + '/banner/allList',
        getResource: api + '/resource/list',
    },
    // 问卷调查
    questions: {
        getList: api + '/qsa/getFillDetail',
        submitForm: api + '/qsa/fillQsa'
    }
}